export default "__VITE_ASSET__VJSXEgjI__"